/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserVoteEntry = /* GraphQL */ `
  query GetUserVoteEntry($id: ID!) {
    getUserVoteEntry(id: $id) {
      id
      username
      entry_id
      vote
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUserVoteEntrys = /* GraphQL */ `
  query ListUserVoteEntrys(
    $filter: ModelUserVoteEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserVoteEntrys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        entry_id
        vote
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getUserFlagEntry = /* GraphQL */ `
  query GetUserFlagEntry($id: ID!) {
    getUserFlagEntry(id: $id) {
      id
      username
      entry_id
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUserFlagEntrys = /* GraphQL */ `
  query ListUserFlagEntrys(
    $filter: ModelUserFlagEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFlagEntrys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        entry_id
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getUserDisclaimerEntry = /* GraphQL */ `
  query GetUserDisclaimerEntry($id: ID!) {
    getUserDisclaimerEntry(id: $id) {
      id
      accepted
      createdAt
      updatedAt
    }
  }
`;
export const listUserDisclaimerEntrys = /* GraphQL */ `
  query ListUserDisclaimerEntrys(
    $filter: ModelUserDisclaimerEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserDisclaimerEntrys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accepted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserFirstVisitEntry = /* GraphQL */ `
  query GetUserFirstVisitEntry($id: ID!) {
    getUserFirstVisitEntry(id: $id) {
      id
      username
      first_visit
      product_version
      createdAt
      updatedAt
    }
  }
`;
export const listUserFirstVisitEntrys = /* GraphQL */ `
  query ListUserFirstVisitEntrys(
    $filter: ModelUserFirstVisitEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFirstVisitEntrys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        first_visit
        product_version
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserMetadata = /* GraphQL */ `
  query GetUserMetadata($id: ID!) {
    getUserMetadata(id: $id) {
      id
      lastLoggedIn
      createdAt
      updatedAt
    }
  }
`;
export const listUserMetadatas = /* GraphQL */ `
  query ListUserMetadatas(
    $filter: ModelUserMetadataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserMetadatas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        lastLoggedIn
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserRole = /* GraphQL */ `
  query GetUserRole($id: ID!) {
    getUserRole(id: $id) {
      id
      username
      accessGroups
      role
      projects {
        items {
          id
          projectID
          userID
          accessGroups
          user {
            id
            username
            accessGroups
            role
            projects {
              nextToken
            }
            createdAt
            updatedAt
          }
          project {
            id
            owner
            name
            description
            projectPreference
            snippets {
              nextToken
            }
            users {
              nextToken
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUserRoles = /* GraphQL */ `
  query ListUserRoles(
    $filter: ModelUserRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        accessGroups
        role
        projects {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserProject = /* GraphQL */ `
  query GetUserProject($id: ID!) {
    getUserProject(id: $id) {
      id
      projectID
      userID
      accessGroups
      user {
        id
        username
        accessGroups
        role
        projects {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      project {
        id
        owner
        name
        description
        projectPreference
        snippets {
          items {
            id
            owner
            accessGroups
            projectID
            hit {
              bucket
              region
              key
            }
            pageNum
            hitIdx
            identityID
            hitHashCode
            description
            query
            mode
            filters
            actionDateStart
            actionDateEnd
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        users {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUserProjects = /* GraphQL */ `
  query ListUserProjects(
    $filter: ModelUserProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectID
        userID
        accessGroups
        user {
          id
          username
          accessGroups
          role
          projects {
            items {
              id
              projectID
              userID
              accessGroups
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        project {
          id
          owner
          name
          description
          projectPreference
          snippets {
            items {
              id
              owner
              accessGroups
              projectID
              pageNum
              hitIdx
              identityID
              hitHashCode
              description
              query
              mode
              filters
              actionDateStart
              actionDateEnd
              createdAt
              updatedAt
            }
            nextToken
          }
          users {
            items {
              id
              projectID
              userID
              accessGroups
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSearchResults = /* GraphQL */ `
  query GetSearchResults($id: ID!) {
    getSearchResults(id: $id) {
      id
      accessGroups
      projectID
      title
      description
      filters
      offset
      query
      mode
      actionDateStart
      actionDateEnd
      prevNumPages
      createdAt
      updatedAt
    }
  }
`;
export const listSearchResultss = /* GraphQL */ `
  query ListSearchResultss(
    $filter: ModelSearchResultsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSearchResultss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accessGroups
        projectID
        title
        description
        filters
        offset
        query
        mode
        actionDateStart
        actionDateEnd
        prevNumPages
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSnippet = /* GraphQL */ `
  query GetSnippet($id: ID!) {
    getSnippet(id: $id) {
      id
      owner
      accessGroups
      projectID
      hit {
        bucket
        region
        key
      }
      pageNum
      hitIdx
      identityID
      hitHashCode
      description
      query
      mode
      filters
      actionDateStart
      actionDateEnd
      project {
        id
        owner
        name
        description
        projectPreference
        snippets {
          items {
            id
            owner
            accessGroups
            projectID
            hit {
              bucket
              region
              key
            }
            pageNum
            hitIdx
            identityID
            hitHashCode
            description
            query
            mode
            filters
            actionDateStart
            actionDateEnd
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        users {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listSnippets = /* GraphQL */ `
  query ListSnippets(
    $filter: ModelSnippetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSnippets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        accessGroups
        projectID
        hit {
          bucket
          region
          key
        }
        pageNum
        hitIdx
        identityID
        hitHashCode
        description
        query
        mode
        filters
        actionDateStart
        actionDateEnd
        project {
          id
          owner
          name
          description
          projectPreference
          snippets {
            items {
              id
              owner
              accessGroups
              projectID
              pageNum
              hitIdx
              identityID
              hitHashCode
              description
              query
              mode
              filters
              actionDateStart
              actionDateEnd
              createdAt
              updatedAt
            }
            nextToken
          }
          users {
            items {
              id
              projectID
              userID
              accessGroups
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSearch = /* GraphQL */ `
  query GetSearch($id: ID!) {
    getSearch(id: $id) {
      id
      projectID
      description
      filter
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listSearchs = /* GraphQL */ `
  query ListSearchs(
    $filter: ModelSearchFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSearchs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectID
        description
        filter
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getUserTable = /* GraphQL */ `
  query GetUserTable($id: ID!) {
    getUserTable(id: $id) {
      id
      tables
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUserTables = /* GraphQL */ `
  query ListUserTables(
    $filter: ModelUserTableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserTables(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        tables
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getUserAnnotations = /* GraphQL */ `
  query GetUserAnnotations($id: ID!) {
    getUserAnnotations(id: $id) {
      id
      accessGroups
      projectID
      documentID
      annotations
      createdAt
      updatedAt
    }
  }
`;
export const listUserAnnotationss = /* GraphQL */ `
  query ListUserAnnotationss(
    $filter: ModelUserAnnotationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAnnotationss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accessGroups
        projectID
        documentID
        annotations
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDataExtractionRequest = /* GraphQL */ `
  query GetDataExtractionRequest($id: ID!) {
    getDataExtractionRequest(id: $id) {
      id
      username
      name
      documentID
      status
      type
      additionalComments
      annotations
      createdAt
      updatedAt
    }
  }
`;
export const listDataExtractionRequests = /* GraphQL */ `
  query ListDataExtractionRequests(
    $filter: ModelDataExtractionRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataExtractionRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        username
        name
        documentID
        status
        type
        additionalComments
        annotations
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNotificationPreferences = /* GraphQL */ `
  query GetNotificationPreferences($id: ID!) {
    getNotificationPreferences(id: $id) {
      id
      enabled
      frequency
      createdAt
      updatedAt
    }
  }
`;
export const listNotificationPreferencess = /* GraphQL */ `
  query ListNotificationPreferencess(
    $filter: ModelNotificationPreferencesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotificationPreferencess(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        enabled
        frequency
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserSwitchNewUI = /* GraphQL */ `
  query GetUserSwitchNewUI($id: ID!) {
    getUserSwitchNewUI(id: $id) {
      id
      accepted
      createdAt
      updatedAt
    }
  }
`;
export const listUserSwitchNewUIs = /* GraphQL */ `
  query ListUserSwitchNewUIs(
    $filter: ModelUserSwitchNewUIFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserSwitchNewUIs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accepted
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const annotationsByProjectDocumentID = /* GraphQL */ `
  query AnnotationsByProjectDocumentID(
    $projectID: ID
    $documentID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserAnnotationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    annotationsByProjectDocumentID(
      projectID: $projectID
      documentID: $documentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accessGroups
        projectID
        documentID
        annotations
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
